import { render, staticRenderFns } from "./PageWxApplet.vue?vue&type=template&id=748d31ba&scoped=true"
import script from "./PageWxApplet.vue?vue&type=script&lang=js"
export * from "./PageWxApplet.vue?vue&type=script&lang=js"
import style0 from "./PageWxApplet.vue?vue&type=style&index=0&id=748d31ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d31ba",
  null
  
)

export default component.exports